import React from 'react';

import Code from './renderers/Code';

const CodeFeatureCard = ({ reverse, id, ...props }) => {
  return (
    <section key={id} className="md:py-3 px-6">
      <Code {...props} className="w-full h-full my-6" noCopy />
    </section>
  );
};

export default CodeFeatureCard;
